module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/militaryFeatured2.webp";